(function ($) {
	'use strict';

	var HUNDAKADEMIN = {

		init: function () {
			this.mainMenuBlock();
			this.mainMenuBlock1();
			this.submenuOpener();
			this.fixedHeader();
			this.submenuOpenerFooter();
			this.heroSlider();
			this.textimgbox1Slider();
			this.testimonialSlider();
			this.videoSlider();
			this.bookSlider();
			this.pillsOpener();
			this.imgSlider();
			this.blogMenu();
		},



		mainMenuBlock: function () {
			jQuery('header').on('click', '.navbar-toggle-btn', function (e) {
				e.preventDefault();
				if (!jQuery(this).hasClass("nav-open")) {
					jQuery('#navbar').removeClass('active');
					jQuery('html').removeClass('menu-active');
					jQuery(this).removeClass('nav-close').addClass('nav-open');

				} else {
					jQuery('#navbar').addClass('active');
					jQuery('html').addClass('menu-active');
					jQuery(this).removeClass('nav-open').addClass('nav-close');
				}
			});
		},

		mainMenuBlock1: function () {
			jQuery('header').on('click', '.navbar-toggle-btn.nav-close', function (e) {
				jQuery('html').removeClass('submenu-active');
				jQuery('.nav-item').removeClass('opened');
				jQuery('.submenu-opener').removeClass('closed');
				jQuery('.dropdown-menu').css("display", "none");
			});
		},

		submenuOpener: function () {
			jQuery("header.main-header .navbar-nav .submenu-opener.depth_0").on('click', function (e) {
				// e.preventDefault();
				jQuery('html').toggleClass('submenu-active');

				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).parent('.nav-item').addClass('opened');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).parent('.nav-item').removeClass('opened');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}

			});

			jQuery("header.main-header .navbar-nav .submenu-opener.depth_1").on('click', function (e) {
				// e.preventDefault();
				// jQuery('html').toggleClass('submenu-active');

				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}

			});

		},



		fixedHeader: function () {
			jQuery(window).scroll(function () {
				var sticky = jQuery('header'),
					scroll = jQuery(window).scrollTop();

				if (scroll >= 30) sticky.addClass('sticky-header');
				else sticky.removeClass('sticky-header');
			});
		},

		submenuOpenerFooter: function () {
			jQuery(".footer-menu-block .submenu-opener").on('click', function (e) {
				// e.preventDefault();


				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}

			});

		},

		heroSlider: function () {
			var $mainslider = $('.hero-slider')


			// Slick Slider Options
			$mainslider.slick({
				draggable: true,
				arrows: true,
				dots: true,
				fade: true,
				infinite: true,
				speed: 1000,
				autoplay: true,
				autoplaySpeed: 10000,
				// mobileFirst: true,
				// pauseOnHover: true,
			});

			// Slider Progressbar Start Here
			var time = 10;
			var $bar,
				$mainslider,
				isPause,
				tick,
				percentTime;

			$bar = $('.slider-progress .progress');

			function startProgressbar() {
				resetProgressbar();
				percentTime = 0;
				isPause = false;
				tick = setInterval(interval, 15);
			}

			function interval() {
				if (isPause === false) {
					percentTime += 1 / (time + 0.1);
					$bar.css({
						width: percentTime + "%"
					});
					if (percentTime >= 100) {
						$mainslider.slick('slickNext');
					}
				}
			}
			function resetProgressbar() {
				$bar.css({
					width: 0 + '%'
				});
				clearTimeout(tick);
			}
			// Reset Progressbar When Slide Change
			$mainslider.on('afterChange', function (event, slick, currentSlide) {
				startProgressbar();
			});

			$('.hero-block').on({
				mouseenter: function () {
					isPause = true;
				},
				mouseleave: function () {
					isPause = false;
				}
			})
			startProgressbar();

		},


		textimgbox1Slider: function () {
			$('.text-img-box1-slider').slick({
				dots: false,
				arrows: false,
				infinite: false,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 1,
				adaptiveHeight: true,
				responsive: [

					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2.8,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1.8,

						}
					},
				]
			});
		},

		testimonialSlider: function () {
			$('.testimonial-slider').slick({
				dots: false,
				arrows: true,
				infinite: false,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 1,
				adaptiveHeight: true,
				responsive: [

					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,

						}
					},
				]
			});
		},

		videoSlider: function () {
			$('.video-slider').slick({
				dots: false,
				arrows: false,
				infinite: false,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 1,
				adaptiveHeight: true,
				responsive: [


					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,

						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1.2,

						}
					},
				]
			});
		},

		bookSlider: function () {
			$('.book-slider').slick({
				dots: false,
				arrows: false,
				infinite: false,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 1,
				adaptiveHeight: true,
				responsive: [

					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2.6,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1.6,

						}
					},
				]
			});
		},


		pillsOpener: function () {
			jQuery('.pills-opener').on('click', function () {

				jQuery('.pills-tab-wrapper').toggleClass('open-navpills');

			});

			jQuery('.pills-tab-wrapper a.nav-link').on('click', function () {

				jQuery('.pills-tab-wrapper').removeClass('open-navpills');

			});
		},
		imgSlider: function () {
			var $status = $('.pagingInfo');
			var $slickElement = $('.img-slider');

			$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
				//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
				var i = (currentSlide ? currentSlide : 0) + 1;
				$status.text(i + ' / ' + slick.slideCount);
			});

			$slickElement.slick({
				autoplay: false,
				dots: false,
				arrows: true,
				adaptiveHeight: true,
			});
		},

		blogMenu: function () {

			$('.archive-menu >ul li:first').addClass('open');
			$('.archive-menu >ul li:first > ul').css("display", "block");
			$('.archive-menu >ul li:first ul li:first').addClass('open');
			$('.archive-menu >ul li:first > ul li:first > ul').css("display", "block");

			$(".archive-menu .parent > a > i").click(function (e) {
				e.preventDefault();
				var toClose = $(".archive-menu ul").not($(this).parents("ul"));
				toClose.slideUp();
				toClose.parent().removeClass("open");
				if (!$(this).parent().next().is(":visible")) {
					var toOpen = $(this).parent().next()
					toOpen.slideDown();
					toOpen.parent().not(".open").addClass("open");
				}
				// e.stopPropagation();
			});


			$(".archive-listing .heading-block i").click(function () {
				$(".archive-menu-wrapper").slideToggle();
				$("i", $(".heading-block")).toggleClass("icon-down-med").toggleClass("icon-up-med");
			})
		},








	};

	HUNDAKADEMIN.init();

})(jQuery);



